import React, { Fragment } from 'react';
import { Typography, Link } from '@material-ui/core';
import ConfirmDialog from './ConfirmDialog';

const Name = ({ label, onClick }) => (
    onClick
        ? <Link component="button" type="button" onClick={onClick} style={{ fontWeight: 700, verticalAlign: 'baseline' }}>{label}</Link>
        : <strong>{label}</strong>
);

const boldSentence = (items, onClick) => items.map((item, index) => (
    <Fragment key={item}>
        {index > 0 && (index === items.length - 1 ? ' and ' : ', ')}
        <Name label={item} onClick={onClick} />
    </Fragment>
));

const LinkedinSyncConfirmDialog = ({ open, currentContactLabel, otherContactLabels, onNameClick, onConfirm, onCancel, onClose }) => (
    <ConfirmDialog
        open={open}
        title="This contact exists in another area of the database."
        onConfirm={onConfirm}
        onCancel={onCancel}
        onClose={onClose}
        showCloseIcon
        confirmText="Yes"
        cancelText="No"
    >
        <Typography>
            Match detected between <Name label={currentContactLabel} onClick={onNameClick} /> and {boldSentence(otherContactLabels || [], onNameClick)}.
            Would you like to update the LinkedIn URL on their other profile(s) as well?
        </Typography>
    </ConfirmDialog>
);

export default LinkedinSyncConfirmDialog;